var version="9.6.3";export{version as v};
//# sourceMappingURL=package-08481267.js.map
